<!--订单列表-->
<template>
  <Page>
    <template v-slot:contentTop>
      <div class="infoView-box">
        <div class="pageContent-title">
          订单信息
        </div>
        <div class="info-content">
          <a-form class="flex-form form-label-7" style="margin-top: 20px" :form="order">
            <div class="grid grid-cols-3 2xl:grid-cols-3 gap-2">
              <div style="height: 32px;margin-bottom: 10px">
                <span>产品名称：</span>
                <span>{{ order.travelName }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>订单号：</span>
                <span>{{ order.orderNo }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>团号：</span>
                <span>{{ order.travelCode }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>订单状态：</span>
                <span>{{ statusList[order.status] }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>订单金额：</span>
                <span>{{ order.totalAmount }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>下单时间：</span>
                <span>{{ order.orderTime }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>下单人：</span>
                <span>{{ order.contactName }}</span>
              </div>
              <div style="height: 32px;margin-bottom: 10px">
                <span>联系电话：</span>
                <span>{{ order.contactMobile }}</span>
              </div>
            </div>
          </a-form>
        </div>
        <!-- <div class="info-button">
        <a-button type="primary" v-if="order.status == 30" @click="toRefund">退款</a-button>
        <a-button type="primary" @click="toRefund">退款</a-button>
        </div> -->
      </div>
    </template>

    <!-- 支付及快递信息 -->
    <!-- <div class="infoView-box">
      <div class="pageContent-title">
        出行人信息
      </div>
      <div class="customer-list">
        <div v-for="(c, i) in order.travelOrderDetailList" class="customer-item" :key="i">
          <span>{{ c.nameCn }}:</span>
          <span style="margin-left: 10px">{{ c.passportNo }}</span>
        </div>
      </div>
    </div> -->
    <div class="infoView-box">
      <div class="pageContent-title">
        支付信息
      </div>
      <div class="pay" v-if="order.paymentDetailList && order.paymentDetailList.length">
        <div class="pay-info" v-for="(pay, index) in order.paymentDetailList" :key="index">
          <div class="pay-info-item">
            <span>支付类型:</span>
            <div style="width: 10px "></div>
            <span>
              {{
                pay.paymentType && pay.paymentType == 0
                  ? '订金'
                  : pay.paymentType == 10
                  ? '尾款'
                  : pay.paymentType == 20
                  ? '全款'
                  : pay.paymentType == 30
                  ? '退款'
                  : ''
              }}
            </span>
          </div>
          <div class="pay-info-item">
            <span>{{ pay.paymentType == 30 ? '退款' : '支付' }}时间:</span>
            <div style="width: 10px "></div>
            <span>{{ pay.paymentTime ? pay.paymentTime : 0 }}</span>
          </div>
          <div class="pay-info-item">
            <span>{{ pay.paymentType == 30 ? '退款' : '支付' }}金额:</span>
            <div style="width: 10px "></div>
            <span>{{ pay.amount ? pay.amount : 0 }}</span>
          </div>
        </div>
        <!-- 分割线 -->
        <a-divider v-if="refundInfo" />
        <template v-if="refundInfo"></template>
        <div class="refund-info" v-for="(item, index) in refundInfo" :key="index">
          <div class="refund-info-item">
            <span>退款金额:</span>
            <span>{{ item.amount ? item.amount : 0 }}</span>
          </div>
          <div class="refund-info-item">
            <span>退款时间:</span>
            <span>{{ item.payTime }}</span>
          </div>
        </div>
      </div>
      <div v-else style="display: flex; justify-content: center;align-items: center;height: 200px">
        暂无信息
      </div>
    </div>

    <a-modal
      title="退款"
      :width="900"
      v-model="refundModel"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="refund">
        <p class="refund-title">初始支付信息</p>
        <div class="refund-pay" v-if="payInfo">
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">支付时间:</div>
            <div class="refund-pay-item-content">{{ payInfo.payTime }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">订单号:</div>
            <div class="refund-pay-item-content">{{ order.orderNo }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">支付金额:</div>
            <div class="refund-pay-item-content">{{ payInfo.amount }}</div>
          </div>
        </div>
        <div class="refund-pay" v-for="(refund, index) in refundInfo" :key="index">
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">退款时间:</div>
            <div class="refund-pay-item-content">{{ refund.payTime }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">订单号:</div>
            <div class="refund-pay-item-content">{{ order.orderNo }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">退款金额:</div>
            <div class="refund-pay-item-content">{{ refund.amount }}</div>
          </div>
        </div>
        <p class="refund-title">退款金额</p>
        <div class="refund-amount">
          <a-checkbox-group v-model="checkedList" @change="onChange" class="refund-checkbox-group">
            <div
              style="width: 80px;display: flex;margin-right: 20px;"
              v-for="(item, index) in order.travelOrderDetailList"
              :key="index"
            >
              <a-checkbox :value="item.id" :disabled="item.refundTime">{{ item.nameCn }}</a-checkbox>
            </div>
          </a-checkbox-group>
          <div class="refund-amount-item">
            退款金额
            <a-input-number
              v-model="refundAmount"
              :min="1"
              :max="Number(order.orderPayAmount) - Number(order.refundAmount)"
              placeholder="请输入退款金额"
              style="width: 200px;margin:0 10px"
            />

            可退金额 {{ Number(order.orderPayAmount) - Number(order.refundAmount) }}
          </div>
        </div>
        <a-divider />
        <p class="refund-title">退款备注</p>
        <div class="refund-remark">
          <a-textarea v-model="refundRemark" placeholder="请输入退款备注" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </div>
      </div>
    </a-modal>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin, queryViewMixin } from '@/utils/mixin'

export default {
  mixins: [toolMixin, queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '80px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '时间',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '内容',
        align: 'center',
        dataIndex: 'content',
      },
      {
        title: '操作人',
        align: 'center',
        dataIndex: 'operator',
      },
    ]
    return {
      orderNo: null,
      tableLoading: false,
      refundAmount: 0,
      refundRemark: '',
      checkedList: [],
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      order: {},
      refundInfo: {},
      payInfo: {},
      addressData: {},
      refundModel: false,
      confirmLoading: false,
      tableColumns,
      editSendAddress: {},
      editReturnAddress: [],
      dataSource: [],
      // 出行人
      plainOptions: [],
      statusList: {
        '-1': '已取消',
        '0': '待支付',
        '10': '待发货',
        '20': '已发货',
      },
    }
  },
  components: {
    Page,
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo
    this.doQuery(this.orderNo)
  },
  methods: {
    getLogList(orderNo) {
      this.$axios
        .get('/mall/admin/log/order', {
          params: {
            orderNo: orderNo,
          },
        })
        .then(res => {
          if (res.success) {
            this.dataSource = res.data
          }
        })
    },
    getPayInfo(orderNo) {
      this.$axios
        .get('/mall/admin/travel/order/payInfo', {
          params: {
            orderNo: orderNo,
          },
        })
        .then(res => {
          if (res.success) {
            this.refundInfo = res.data.refundInfo
            this.payInfo = res.data.payInfo
          }
        })
    },
    handleOk() {
      this.confirmLoading = true
      this.$axios
        .post('/mall/admin/travel/order/refund', {
          orderNo: this.orderNo,
          orderDetailIds: this.checkedList,
          refundAmount: this.refundAmount,
          remark: this.refundRemark,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('退款成功')
            this.refundModel = false
            this.doQuery(this.orderNo)
          }
          this.confirmLoading = false
        })
    },
    handleCancel() {
      this.refundModel = false
    },
    onChange(checkedList) {
      console.log('checked = ', checkedList)
    },
    // 退款
    toRefund() {
      this.refundModel = true
    },
    // 获取详情信息
    async doQuery(orderNo) {
      try {
        const res = await this.$axios.get(`/po/admin/travel/order/${orderNo}`)
        if (res.success) {
          this.order = res.data
        }
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.infoView-box {
  .info-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .info-button {
    margin-top: 20px;
    text-align: center;
  }
  .customer-list {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
    .customer-item {
      width: 200px;
      height: 50px;
      border-radius: 10px;
      display: flex;
      border: 1px solid #079a92;
      background: #d0ecea;
      color: #079a92;
      font-size: 18px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  .pay {
    display: flex;
    flex-direction: column;
    .pay-info {
      display: flex;
      .pay-info-item {
        width: 33.33%;
        display: flex;
        height: 50px;
        padding-top: 25px;
      }
    }
    .refund-info {
      display: flex;
      .refund-info-item {
        display: flex;
        height: 50px;
        span {
          width: 300px;
        }
      }
    }
  }
}

.refund {
  width: 100%;
  margin: 0 auto;
  .refund-title {
    line-height: 30px;
  }
  .refund-pay {
    width: 100%;
    min-height: 50px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .refund-pay-item {
      display: flex;
      line-height: 30px;
      .refund-pay-item-title {
        width: 80px;
      }
    }
  }
  .refund-amount {
    width: 100%;
    min-height: 100px;
    .refund-checkbox-group {
      width: 100%;
      display: flex;
      padding: 20px;
    }
    .refund-amount-item {
      display: flex;
      line-height: 30px;
      padding: 20px;
    }
  }
  .refund-remark {
    width: 100%;
    min-height: 100px;
  }
}
</style>
